import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'

interface IStatisticsSubmitHeader {
  label: string
  acitveStep?: string
}

const StatisticsSubmitHeader = ({ label, acitveStep }: IStatisticsSubmitHeader) => {
  return (
    <div className="flex flex-row gap-1 w-full justify-center items-center mb-12 flex-wrap">
      <div className={acitveStep === '1' ? 'step-btn-active' : 'step-btn'}>
        <span>{label}</span>
      </div>
      <hr className="w-8 h-px my-8 bg-darkBlue border-0 dark:darkBlue"></hr>
      <div className={acitveStep === '2' ? 'step-btn-active' : 'step-btn'}>
        <span>Faktureringsuppgifter</span>
      </div>
      <hr className="w-8 h-px my-8 bg-darkBlue border-0 dark:darkBlue"></hr>
      <div className={acitveStep === '3' ? 'step-btn-active' : 'step-btn'}>
        <span>Användare</span>
      </div>
      <hr className="w-8 h-px my-8 bg-darkBlue border-0 dark:darkBlue"></hr>
      <div>
        <FontAwesomeIcon icon={faCheckCircle} size="2x" className="black-opacity" />
      </div>
    </div>
  )
}

export default StatisticsSubmitHeader
